export default __webpack_public_path__ + "static/media/wide.fdcf71e4.png";